import { useEffect, useState } from 'react';
import { useAuthService } from '../context/AuthServiceContext.js';
/**
 * Subscribes to auth state changes via the injected auth service.
 * `user.orgIds` carries the Firebase custom claim set by SysColect's identity layer.
 */
export function useCurrentUser() {
    const authService = useAuthService();
    const [user, setUser] = useState(() => authService.getCurrentUser());
    const [isLoading, setIsLoading] = useState(() => authService.getCurrentUser() === null);
    useEffect(() => {
        const unsubscribe = authService.onAuthStateChanged((next) => {
            setUser(next);
            setIsLoading(false);
        });
        return unsubscribe;
    }, [authService]);
    return { user, isLoading };
}
//# sourceMappingURL=useCurrentUser.js.map